import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { SectionCta } from './SectionCta';
export function Guarantee() {
  return <section className="w-full bg-ink-950 px-4 py-14 sm:px-6 sm:py-20" data-id="element-123" data-mp="1o33uyj8shwit">
      <div className="mx-auto w-full max-w-2xl rounded-3xl border border-white/10 bg-ink-800 p-6 text-center sm:p-8" data-id="element-124" data-mp="223og3m26g4fh">
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-lime/15" data-id="element-125" data-mp="1x5mtws9gfozs">
          <ShieldCheckIcon className="h-7 w-7 text-lime" data-id="element-126" data-mp="19fipiiofzl7q" />
        </span>
        <h2 className="mt-4 font-display text-xl text-white sm:text-3xl" data-id="element-127" data-mp="14gfmt4vxpr2x">Your 7-day guarantee</h2>
        <p className="mt-3 text-sm leading-relaxed text-white/70 sm:text-base" data-id="element-128" data-mp="1j4tz06f8qrw5">
          We want you to be able to review the entire system without taking a risk. Get instant
          access, explore the clinical volumes and tools, and see whether the Anti-Refinement
          System™ fits your workflow.
        </p>
        <p className="mt-3 text-sm leading-relaxed text-white/70 sm:text-base" data-id="element-129" data-mp="lodcscdst91n">
          If you’re not satisfied within the first 7 days, contact our support team and request a
          refund. No long-term commitment. No subscription. No recurring charges.
        </p>
        <SectionCta headline="Try the full system risk-free for 7 days." data-id="element-130" data-mp="yot5y6i875gf" />
      </div>
    </section>;
}